import React from 'react';

import { SectionBlock } from '../../../../blocks/SectionBlock';
import { useBlockers } from '../../hooks/useBlockers';

import { Blockers } from './Blockers';

export function SprintSummary(): JSX.Element {
  const { data: blockers = [], isLoading, error } = useBlockers();
  return (
    <SectionBlock skipContentContainer>
      <Blockers blockers={blockers} isLoading={isLoading} error={error} />
    </SectionBlock>
  );
}
